
export default () => ({
    pinnedSection: null,
    pinContainer: null,
    words: null,
    wordCount: null,
    init() {
    },
    runAnimation(section){
       this.pinnedSection = section
       if (!this.pinnedSection) return
      
        this.pinContainer = this.pinnedSection.querySelector(".pin-container-js")
        this.words = this.pinnedSection.querySelectorAll(".animated-rich-text__text--foreground .animated-rich-text__text-word")
            this.wordCount = this.words.length
        const halfScreenHeight = window.innerHeight / 2;

           
            if(this.pinContainer){
                const rect = this.pinContainer.getBoundingClientRect()
                let progress
                let distanceFromTop = rect.top - halfScreenHeight;
                let containerHeight = rect.height;
      
                // 1) If the container hasn't reached the middle of the viewport yet,
                //    the text is not pinned => progress=0
                if (distanceFromTop > 0) {
                  progress = 0
                }
                // 2) If the container's bottom is already above the middle from bottom of the viewport,
                //    that means we've scrolled past the pinned area => progress=1
                
                else if (rect.bottom + containerHeight <= containerHeight) {
                  progress = 1
                }
                // 3) Otherwise, we are in the middle section range
                else {
                  // How far we've scrolled inside that section region is simply -rect.top
                  // (i.e., how many pixels the container's top is above the top of the viewport)
                  const scrolled = distanceFromTop * -1;
                  progress = scrolled / containerHeight
           
                }
      
                // clamp progress 0..1
                progress = Math.max(0, Math.min(1, progress))
      
                // Now do the word reveal
                const slice = 1 / this.wordCount
      
                this.words.forEach((word, i) => {
                  const start = i * slice
                  const end = (i + 1) * slice
      
                  if (progress < start) {
                    word.style.setProperty("--reveal-amount", "0%")
                    word.classList.remove('animatad-word')
                  } else if (progress > end) {
                    word.style.setProperty("--reveal-amount", "100%")
                    word.classList.add('animatad-word')
                  } else {
                    const localProgress = (progress - start) / (end - start)
                    const revealAmount = localProgress * 100
                    word.style.setProperty("--reveal-amount", revealAmount + "%")
                    word.classList.remove('animatad-word')
                  }
                })

            }
        
    }
})
